import ApiClientBase from './ApiClientBase';
import { axiosInstanceSADL } from 'services/APIService';
import { SadlSet } from 'api/models/Sets';

class SetsSadlEndpoint extends ApiClientBase {
  apiUri = '/v2/sets';

  axiosInstance = axiosInstanceSADL;

  getSet({ serial, supplier_tenant_name }: { serial: string; supplier_tenant_name: string }) {
    // for test data use ZZINAUK0001
    const queryParams = new URLSearchParams({ supplier_tenant_name });

    return this.apiCall<SadlSet>({
      uri: serial,
      data: queryParams,
    });
  }
}

const endpoint = new SetsSadlEndpoint();
export default endpoint;
